








import { Component,  Vue } from 'vue-property-decorator'; 
import {mapState} from 'vuex'
import Item from '@/components/WineBox/Item.vue'

@Component({
  components: { 
      Item
  },
  computed: mapState([ 
    'carrinho',
  ]),
})
export default class Itens extends Vue {  
}
